"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  BeaconRemoteHouse: ['beacon-remote-house', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.563,7.674l-11-7.5a1,1,0,0,0-1.126,0l-11,7.5A1,1,0,1,0,1.563,9.326L2,9.028V17.5a1,1,0,0,0,2,0V7.8a.252.252,0,0,1,.109-.207l7.75-5.284a.25.25,0,0,1,.282,0l7.75,5.284A.252.252,0,0,1,20,7.8v9.7a1,1,0,0,0,2,0V9.028l.437.3a1,1,0,0,0,1.126-1.652Z', 'M16.949,8.464a1,1,0,0,0,0-1.414,7,7,0,0,0-9.9,0A1,1,0,0,0,8.465,8.464a5,5,0,0,1,7.07,0A1,1,0,0,0,16.949,8.464Z', 'M12,8.5A4.966,4.966,0,0,0,8.465,9.964a1,1,0,0,0,0,1.414,1.067,1.067,0,0,0,1.414,0c2.027-2.026,4.328.061,4.425.122a.989.989,0,0,0,1.231-1.536A4.966,4.966,0,0,0,12,8.5Z', 'M17.5,14.5A1.5,1.5,0,0,0,16,13H8a1.5,1.5,0,0,0-1.5,1.5v8A1.5,1.5,0,0,0,8,24h8a1.5,1.5,0,0,0,1.5-1.5v-8Zm-4.659,5.772a.248.248,0,0,0-.091.193V21.75a.75.75,0,0,1-1.5,0V20.473a.251.251,0,0,0-.091-.193,1.277,1.277,0,0,1-.492-.989,1.333,1.333,0,1,1,2.666,0A1.267,1.267,0,0,1,12.841,20.272ZM15.25,19.5a.75.75,0,0,1-.75-.75,2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,15.25,19.5Z']],
  BeaconRemoteLaptop: ['beacon-remote-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.924,10.041l-1.4-3.24c0-.01-.016-.014-.021-.024V2.5a2.144,2.144,0,0,0-2.16-2H14.5a2,2,0,0,0-2,2V6.777c0,.01-.016.014-.02.024L11.07,10.065a1.061,1.061,0,0,0,.995,1.435H22.938a1.062,1.062,0,0,0,.986-1.459ZM20.5,6.25a.25.25,0,0,1-.25.25h-5.5a.25.25,0,0,1-.25-.25V2.75a.25.25,0,0,1,.25-.25h5.5a.25.25,0,0,1,.25.25Z', 'M5.5,7.5A4.966,4.966,0,0,0,1.966,8.964,1,1,0,0,0,3.38,10.378a3.074,3.074,0,0,1,4.242,0A1,1,0,0,0,9.036,8.964,4.966,4.966,0,0,0,5.5,7.5Z', 'M1.966,7.207a5,5,0,0,1,7.07,0A1,1,0,0,0,10.45,5.793a7,7,0,0,0-9.9,0A1,1,0,0,0,1.966,7.207Z', 'M11,14a1.5,1.5,0,0,0-1.5-1.5h-8A1.5,1.5,0,0,0,0,14v8a1.5,1.5,0,0,0,1.5,1.5h8A1.5,1.5,0,0,0,11,22V14ZM6.342,19.772a.252.252,0,0,0-.091.193V21.25a.75.75,0,0,1-1.5,0V19.973a.251.251,0,0,0-.091-.193,1.277,1.277,0,0,1-.492-.989,1.333,1.333,0,0,1,2.666,0A1.266,1.266,0,0,1,6.342,19.772ZM8.751,19A.75.75,0,0,1,8,18.25a2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,8.751,19Z']],
  BeaconBluetooth: ['beacon-bluetooth', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.694,9.836a.25.25,0,0,0,.427.176l.558-.558a.25.25,0,0,0-.02-.372L12.1,8.635a.25.25,0,0,0-.406.2Z', 'M11.694,15.669a.25.25,0,0,0,.406.2l.559-.447a.25.25,0,0,0,.02-.372l-.558-.559a.25.25,0,0,0-.427.177Z', 'M18.5,4.75H5.5a1,1,0,0,0-1,1v12a2,2,0,0,0,2,2h11a2,2,0,0,0,2-2v-12A1,1,0,0,0,18.5,4.75ZM14.53,14.775a.75.75,0,0,1-.061,1.116l-3.056,2.444a.75.75,0,0,1-1.219-.585V14.664a.25.25,0,0,0-.426-.177l-.738.738a.75.75,0,0,1-1.06-1.061l1.737-1.737a.25.25,0,0,0,0-.354L7.97,10.336A.75.75,0,0,1,9.03,9.275l.738.738a.25.25,0,0,0,.426-.177V6.75a.75.75,0,0,1,1.219-.586l3.056,2.445a.75.75,0,0,1,.061,1.116l-2.348,2.348a.25.25,0,0,0,0,.354ZM17,8.25a1,1,0,1,1,1-1A1,1,0,0,1,17,8.25Z', 'M23.924,4.281l-.293-.707a1,1,0,0,0-.217-.324L21,.836a1,1,0,0,0-.324-.217L19.969.326A1,1,0,0,0,19.586.25H4.414a1,1,0,0,0-.383.076L3.324.619A1,1,0,0,0,3,.836L.586,3.25a1,1,0,0,0-.217.324l-.293.707A1.01,1.01,0,0,0,0,4.664V19.336a1.01,1.01,0,0,0,.076.383l.293.707a1,1,0,0,0,.217.324L3,23.164a1,1,0,0,0,.324.217l.707.293a1,1,0,0,0,.383.076H19.586a1,1,0,0,0,.383-.076l.707-.293A1,1,0,0,0,21,23.164l2.414-2.414a1,1,0,0,0,.217-.324l.293-.707A1.01,1.01,0,0,0,24,19.336V4.664A1.01,1.01,0,0,0,23.924,4.281ZM22,19.137l-.141.34-2.132,2.132-.34.141H4.613l-.34-.141L2.141,19.477,2,19.137V4.863l.141-.34L4.273,2.391l.34-.141H19.387l.34.141,2.132,2.132.141.34Z']],
  BeaconRemotePlane1: ['beacon-remote-plane-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.137,3.673a3.541,3.541,0,0,0-1.181-2.492,3.545,3.545,0,0,0-5.1-.161L12.477,3.4,5.3,1.511A2.256,2.256,0,0,0,3.128,2.1l-.572.572A2.255,2.255,0,0,0,2.99,6.2L6.982,8.594a.249.249,0,0,1,.058.379L4.383,11.986a.252.252,0,0,1-.184.085l-.624.009a2.244,2.244,0,0,0-1.811.587L.475,13.847a1.628,1.628,0,0,0,.451,2.618,10.807,10.807,0,0,1,2.331,1.412,15.621,15.621,0,0,1,1.414,2.334,1.628,1.628,0,0,0,2.651.416l1.137-1.243a2.267,2.267,0,0,0,.6-1.822l.009-.624a.249.249,0,0,1,.084-.184l2.275-2.007a1,1,0,1,0-1.323-1.5L7.412,15.62a1,1,0,0,0-.339.736s0,1.374,0,1.438a.313.313,0,0,1-.077.229l-.546.6a.25.25,0,0,1-.4-.047,12.4,12.4,0,0,0-1.25-2.059,9.052,9.052,0,0,0-2.232-1.423.25.25,0,0,1-.046-.4l.608-.556a.262.262,0,0,1,.219-.067c.06.011,1.437,0,1.437,0a1,1,0,0,0,.737-.338L9.534,9.17A1,1,0,0,0,9.3,7.651L4.018,4.483a.255.255,0,0,1-.048-.4l.573-.573a.25.25,0,0,1,.244-.066l7.736,2.036a1,1,0,0,0,.962-.26l2.788-2.787a1.5,1.5,0,0,1,2.213.1.97.97,0,0,0,.112.11,1.491,1.491,0,0,1,.534,1.1.22.22,0,0,0,.2.211,8.466,8.466,0,0,1,1.483.274.248.248,0,0,0,.211-.036.252.252,0,0,0,.106-.186A3.129,3.129,0,0,0,21.137,3.673Z', 'M18.5,5.409a6.952,6.952,0,0,0-4.949,2.05,1,1,0,1,0,1.414,1.414,5,5,0,0,1,7.07,0,1,1,0,1,0,1.414-1.414A6.952,6.952,0,0,0,18.5,5.409Z', 'M24,14.5A1.5,1.5,0,0,0,22.5,13h-8A1.5,1.5,0,0,0,13,14.5v8A1.5,1.5,0,0,0,14.5,24h8A1.5,1.5,0,0,0,24,22.5Zm-4.659,5.777a.247.247,0,0,0-.091.192v1.281a.75.75,0,0,1-1.5,0V20.473a.251.251,0,0,0-.091-.193,1.278,1.278,0,0,1-.492-.991,1.333,1.333,0,1,1,2.666,0A1.272,1.272,0,0,1,19.341,20.274ZM21.75,19.5a.75.75,0,0,1-.75-.75,2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,21.75,19.5Z', 'M22.035,10.373a5,5,0,0,0-7.07,0,1,1,0,0,0,1.414,1.414,3.074,3.074,0,0,1,4.242,0,1,1,0,0,0,1.414-1.414Z']],
  BeaconRemoteSmartphone: ['beacon-remote-smartphone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,8A4.966,4.966,0,0,0,1.965,9.464a1,1,0,0,0,1.414,1.414,3.074,3.074,0,0,1,4.242,0A1,1,0,0,0,9.035,9.464,4.966,4.966,0,0,0,5.5,8Z', 'M1.965,7.707a5,5,0,0,1,7.07,0,1,1,0,1,0,1.414-1.414,7,7,0,0,0-9.9,0A1,1,0,0,0,1.965,7.707Z', 'M22.5,0h-8A1.5,1.5,0,0,0,13,1.5V15a1.5,1.5,0,0,0,1.5,1.5h8A1.5,1.5,0,0,0,24,15V1.5A1.5,1.5,0,0,0,22.5,0ZM22,3v9a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1h5A1,1,0,0,1,22,3Z', 'M11,14.5A1.5,1.5,0,0,0,9.5,13h-8A1.5,1.5,0,0,0,0,14.5v8A1.5,1.5,0,0,0,1.5,24h8A1.5,1.5,0,0,0,11,22.5v-8ZM6.341,20.272a.249.249,0,0,0-.091.193V21.75a.75.75,0,0,1-1.5,0V20.473a.247.247,0,0,0-.091-.192,1.28,1.28,0,0,1-.492-.989,1.333,1.333,0,1,1,2.666,0A1.264,1.264,0,0,1,6.341,20.272ZM8.75,19.5A.75.75,0,0,1,8,18.75a2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,8.75,19.5Z']],
  BeaconRemoteTrain: ['beacon-remote-train', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.656,6.324c-.494-.52-1.883-1.759-4.13-3.682A7.81,7.81,0,0,0,13.459.75H1a1,1,0,0,0,0,2h9.023a.249.249,0,0,1,.214.121L11.7,5.308A4.019,4.019,0,0,0,15.13,7.25h1.89a.25.25,0,0,1,.245.3,8.306,8.306,0,0,0-.038,2.909.255.255,0,0,1-.057.2.25.25,0,0,1-.19.088H14a1,1,0,1,0,0,2h7.431a2.4,2.4,0,0,0,2.289-1.525A4.886,4.886,0,0,0,22.656,6.324ZM13.415,4.279l-.69-1.15a.252.252,0,0,1,0-.252.248.248,0,0,1,.217-.127h.52a5.808,5.808,0,0,1,3.766,1.411l.756.65a.25.25,0,0,1-.163.439H15.13A2.011,2.011,0,0,1,13.415,4.279Zm8.469,6.157a.426.426,0,0,1-.452.314H19.523a.249.249,0,0,1-.242-.191,5.819,5.819,0,0,1,.084-3.152A.25.25,0,0,1,19.6,7.25h1.046a.25.25,0,0,1,.171.068c.17.16.3.29.393.384A2.925,2.925,0,0,1,21.884,10.436Z', 'M22,14.25H14a1,1,0,1,0,0,2h8a1,1,0,1,0,0-2Z', 'M11,13.75a1.5,1.5,0,0,0-1.5-1.5h-8A1.5,1.5,0,0,0,0,13.75v8a1.5,1.5,0,0,0,1.5,1.5h8a1.5,1.5,0,0,0,1.5-1.5ZM6.342,19.54a.251.251,0,0,0-.091.193V21a.75.75,0,0,1-1.5,0V19.734a.248.248,0,0,0-.091-.193,1.291,1.291,0,0,1-.492-1,1.333,1.333,0,0,1,2.666,0A1.286,1.286,0,0,1,6.342,19.54Zm2.409-.79A.75.75,0,0,1,8,18a2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,8.751,18.75Z', 'M3.38,10.628a2.857,2.857,0,0,1,1.226-.706,3.134,3.134,0,0,1,1.79,0,2.857,2.857,0,0,1,1.226.706,1.031,1.031,0,0,0,1.414,0,1,1,0,0,0,0-1.414,5,5,0,0,0-7.07,0,1,1,0,0,0,0,1.414A1.066,1.066,0,0,0,3.38,10.628Z', 'M1.966,7.457a5,5,0,0,1,7.07,0A1,1,0,1,0,10.45,6.043a7,7,0,0,0-9.9,0A1,1,0,0,0,1.966,7.457Z']],
  BeaconRemotePlane: ['beacon-remote-plane', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.647,15.433a.249.249,0,0,1-.32-.275l.685-4.64a1,1,0,0,0-1.3-1.1L6.217,10.568a1,1,0,0,1-1.06-.289l-2.906-3.3a.25.25,0,0,1,.109-.4l1.264-.414a.248.248,0,0,1,.255.061L4.908,7.263A1,1,0,0,0,5.93,7.51L17.8,3.616a1.5,1.5,0,0,1,1.339.206.253.253,0,0,0,.124.046,8.527,8.527,0,0,1,2.019.425.247.247,0,0,0,.255-.057.25.25,0,0,0,.065-.254l-.011-.034a3.5,3.5,0,0,0-4.414-2.232l-2.729.9a.248.248,0,0,1-.221-.032L11.05.36A2.01,2.01,0,0,0,9.281.1L7.5.686a2,2,0,0,0-.8,3.306l.583.588a.25.25,0,0,1-.1.414L6.04,5.369a.251.251,0,0,1-.255-.062L4.756,4.269a1,1,0,0,0-1.022-.246L1.377,4.8A2,2,0,0,0,.5,8.016L3.655,11.6a3,3,0,0,0,3.185.867l1.573-.516a.25.25,0,0,1,.325.274l-.447,3.031A2.009,2.009,0,0,0,8.97,17.1a1.9,1.9,0,0,0,1.817.354l.535-.161a.249.249,0,0,0,.178-.239V15.511a.25.25,0,0,0-.323-.239ZM8.4,2.873a.249.249,0,0,1,.1-.413l1.283-.422a.252.252,0,0,1,.221.033l1.533,1.072a.251.251,0,0,1-.065.443l-1.637.537a.251.251,0,0,1-.256-.062Z', 'M13.551,7.379a1,1,0,0,0,1.414,1.414,5,5,0,0,1,7.07,0,1,1,0,0,0,1.414-1.414,7,7,0,0,0-9.9,0Z', 'M24,14.5A1.5,1.5,0,0,0,22.5,13h-8A1.5,1.5,0,0,0,13,14.5v8A1.5,1.5,0,0,0,14.5,24h8A1.5,1.5,0,0,0,24,22.5v-8Zm-4.659,5.772a.248.248,0,0,0-.091.193V21.75a.75.75,0,0,1-1.5,0V20.473a.249.249,0,0,0-.091-.193,1.277,1.277,0,0,1-.492-.989,1.333,1.333,0,1,1,2.666,0A1.267,1.267,0,0,1,19.341,20.272ZM21.75,19.5a.75.75,0,0,1-.75-.75,2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,21.75,19.5Z', 'M21.328,12a1,1,0,0,0,.707-1.707,5,5,0,0,0-7.07,0,1,1,0,0,0,1.414,1.414,3.072,3.072,0,0,1,4.242,0A1,1,0,0,0,21.328,12Z']],
  BeaconWirelessRemote: ['beacon-wireless-remote', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.4,5.793A1,1,0,0,0,8.818,7.207a4.5,4.5,0,0,1,6.365,0A1,1,0,0,0,16.6,5.793a6.5,6.5,0,0,0-9.193,0Z', 'M6.7,4.2A7.5,7.5,0,0,1,17.3,4.2a1,1,0,1,0,1.414-1.414,9.5,9.5,0,0,0-13.435,0A1,1,0,0,0,6.7,4.2Z', 'M17,9H7a2.5,2.5,0,0,0-2.5,2.5v10A2.5,2.5,0,0,0,7,24H17a2.5,2.5,0,0,0,2.5-2.5v-10A2.5,2.5,0,0,0,17,9Zm-7,7.5a2,2,0,1,1,2.889,1.789.25.25,0,0,0-.139.224V21a.75.75,0,1,1-1.5,0V18.513a.25.25,0,0,0-.139-.224A2,2,0,0,1,10,16.5Zm2-3.749a3.765,3.765,0,0,0-3.76,3.761.75.75,0,0,1-1.5,0,5.261,5.261,0,1,1,10.521,0,.75.75,0,0,1-1.5,0A3.766,3.766,0,0,0,12,12.751Z']],
  BeaconRemoteVehicle: ['beacon-remote-vehicle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12.836a4,4,0,0,0-4-4H18.25a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H20a1.993,1.993,0,0,1,1.8,1.142.25.25,0,0,1-.226.358H19.891a1,1,0,0,0-.971,1.242l.75,3a1,1,0,0,0,.971.758H21.75a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25H20.532a.251.251,0,0,1-.229-.15,2.236,2.236,0,0,0-4.106,0,.251.251,0,0,1-.229.15H8.032a.251.251,0,0,1-.229-.15,2.236,2.236,0,0,0-4.106,0,.251.251,0,0,1-.229.15H2.25a.25.25,0,0,1-.25-.25v-7.75a2,2,0,0,1,1.8-1.991.218.218,0,0,0,.2-.217V9.094a.25.25,0,0,0-.267-.25A4.006,4.006,0,0,0,0,12.836v8a2,2,0,0,0,2,2H3.751a.251.251,0,0,1,.2.1,2.248,2.248,0,0,0,3.6,0,.251.251,0,0,1,.2-.1h8.5a.251.251,0,0,1,.2.1,2.248,2.248,0,0,0,3.6,0,.251.251,0,0,1,.2-.1H22a2,2,0,0,0,2-2Z', 'M7.465,3.629a5,5,0,0,1,7.07,0,1,1,0,1,0,1.414-1.414,7,7,0,0,0-9.9,0A1,1,0,0,0,7.465,3.629Z', 'M16.5,7.336a1.5,1.5,0,0,0-1.5-1.5H7a1.5,1.5,0,0,0-1.5,1.5v8a1.5,1.5,0,0,0,1.5,1.5h8a1.5,1.5,0,0,0,1.5-1.5v-8Zm-4.659,5.772a.248.248,0,0,0-.091.193v1.285a.75.75,0,0,1-1.5,0V13.309a.249.249,0,0,0-.091-.193,1.277,1.277,0,0,1-.492-.989,1.333,1.333,0,1,1,2.666,0A1.267,1.267,0,0,1,11.841,13.108Zm2.409-.772a.75.75,0,0,1-.75-.75,2.5,2.5,0,1,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,1,1,8,0A.75.75,0,0,1,14.25,12.336Z']],
  BeaconRemoteMonitor: ['beacon-remote-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H14a2,2,0,0,0-2,2V8a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H15.5a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.25,2a.25.25,0,0,1,.25.25v4.5a.25.25,0,0,1-.25.25h-7.5A.25.25,0,0,1,14,6.75V2.25A.25.25,0,0,1,14.25,2Z', 'M5.5,8A4.966,4.966,0,0,0,1.965,9.464a1,1,0,0,0,1.414,1.414,3.074,3.074,0,0,1,4.242,0A1,1,0,0,0,9.035,9.464,4.966,4.966,0,0,0,5.5,8Z', 'M1.965,7.707a5,5,0,0,1,7.07,0,1,1,0,1,0,1.414-1.414,7,7,0,0,0-9.9,0A1,1,0,0,0,1.965,7.707Z', 'M11,14.5A1.5,1.5,0,0,0,9.5,13h-8A1.5,1.5,0,0,0,0,14.5v8A1.5,1.5,0,0,0,1.5,24h8A1.5,1.5,0,0,0,11,22.5v-8ZM6.341,20.272a.249.249,0,0,0-.091.193V21.75a.75.75,0,0,1-1.5,0V20.473a.247.247,0,0,0-.091-.192,1.28,1.28,0,0,1-.492-.989,1.333,1.333,0,1,1,2.666,0A1.264,1.264,0,0,1,6.341,20.272ZM8.75,19.5A.75.75,0,0,1,8,18.75a2.5,2.5,0,0,0-5,0,.75.75,0,0,1-1.5,0,4,4,0,0,1,8,0A.75.75,0,0,1,8.75,19.5Z']]
};
exports["default"] = _default;